module.exports = __webpack_public_path__ + "static/img/preview-5.9842523.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/preview/preview-5.png
// module id = L7ZC
// module chunks = 35